export default {
    title: 'My orders',
    surcharge: 'Surcharge',
    delivery: 'Delivery',
    note: "Note",
    headers: {
        store: 'Store',
        orderNumber: 'Order number',
        orderDate: 'Order date',
        quantity: 'Quantity',
        totalSum: 'Total sum',
        status: 'Status'
    },
    buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        remove: 'Remove',
        review: 'Review',
        askSeller: 'Ask Seller',
        viewBill: 'View Bill'
    },
    filter: {
        allStatuses: 'All statuses',
        confirmed: 'Confirmed',
        delivered: 'Delivered',
        inTransit: 'In transit',
        packaging: 'Packaging',
        processed: 'Processed',
        canceled: 'Canceled'
    },
    modal: {
        close: 'Close',
        cancel: 'Cancel',
        confirm: 'Confirm',
        review: 'Review'
    },
    cancelModal: {
        title: 'Cancel order',
        areYouSure: "Are you sure you want to cancel this order? Once canceled, it can't be renewed.",
        successMessage: 'Your order has been canceled successfully.'
    },
    confirmModal: {
        title: 'Confirm order',
        successMessage: 'Your order has been confirmed successfully.'
    },
    reviewModal: {
        title: 'Leave a review',
        rateProduct: 'Rate this product',
        leaveComment: 'Leave a comment',
        optional: 'optional',
        successMessage: 'You left your review successfully.'
    },
    cart: {
        successMessage: 'Items added to cart successfully',
    }
}
